import reqwest from 'reqwest';
import actionTypes from '../constants/actionTypes';
import settings from '../constants/settings';
import checkIntersection from '../logic/checkIntersection';
import parsePolyStrings from '../logic/parsePolyStrings';

export function setLoading(state) {
  return {
    type: actionTypes.SET_LOADING,
    state,
  };
}

export function addReport(report, read = false) {
  return {
    type: actionTypes.MELDUNG_ADD,
    report,
    read,
  };
}
export function removeReport(report) {
  return {
    type: actionTypes.MELDUNG_REMOVE,
    report,
  };
}

export function deleteReport(id) {
  return {
    type: actionTypes.MARK_AS_DELETED,
    id,
  };
}

export function markAsRead(id) {
  return {
    type: actionTypes.MARK_AS_READ,
    id,
  };
}

export function clearReports() {
  return {
    type: actionTypes.CLEAR_REPORTS,
  };
}

export function setOrtSubscriptionId(name, subscriptionId) {
  return {
    type: actionTypes.SET_ORT_SUBSCRIPTION_ID,
    name,
    subscriptionId,
  };
}

export function setOrtArea(name, area) {
  return {
    type: actionTypes.SET_ORT_AREA,
    name,
    area,
  };
}

export function createOrUpdateSubscription(lat, lon, radius, pushActivated, subId, userId, title) {
  return new Promise(resolve => {
    reqwest({
      url: settings.CREATE_UPDATE_SUBSCRIPTION_URL,
      data: {
        lat: lat.toString().replace('.', ','),
        lon: lon.toString().replace('.', ','),
        radius,
        push_activated: pushActivated,
        sub_id: subId,
        user_id: userId,
        title,
        token: localStorage.getItem('uuid'),
      },
      method: 'GET',
      crossOrigin: true,
    }).then(data => {
      resolve(data);
    });
  });
}

export function updateOrte() {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const userId = localStorage.getItem('userid');
    const currentState = getState();
    currentState.orte.forEach(ort => {
      if (ort.coordinates) {
        createOrUpdateSubscription(
          ort.coordinates.lat,
          ort.coordinates.lng,
          ort.radius,
          ort.active,
          ort.subscriptionId || -1,
          userId,
          ort.name,
        ).then(data => {
          dispatch(setOrtSubscriptionId(ort.name, data.id));
          dispatch(setOrtArea(ort.name, data.result));
        });
      }
    });
    dispatch(setLoading(false));
  };
}
export function addOrt(name, lat, lng) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const currentState = getState();
    const isOrtInStore = currentState.orte.some(ort => ort.name === name);
    if (!isOrtInStore) {
      const userId = localStorage.getItem('userid');
      createOrUpdateSubscription(lat, lng, 20, true, -1, userId, name).then(data => {
        dispatch({
          type: actionTypes.ADD_ORT,
          name,
          lat,
          lng,
          subscriptionId: data.id,
          radius: 20,
        });
      });
    }
    dispatch(setLoading(false));
  };
}
export function deleteOrt(subId) {
  return dispatch => {
    dispatch(setLoading(true));
    reqwest({
      url: settings.REMOVE_SUBSCRIPTION_URL,
      data: {
        sub_id: subId,
        token: localStorage.getItem('uuid'),
      },
      method: 'GET',
      crossOrigin: true,
    }).then(() => {
      dispatch({
        type: actionTypes.REMOVE_ORT,
        subscriptionId: subId,
      });
      dispatch(setLoading(false));
    });
  };
}

export function loadReports() {
  return (dispatch, getState) => {
    dispatch(setLoading(true));

    const currentState = getState();

    // dispatch(clearReports());

    const reportsToAdd = [];
    const reportsNotToRemove = [];

    reqwest({
      url: settings.GET_MELDUNGEN_URL,
      data: {
        location: 'allPWA',
      },
      method: 'GET',
      crossOrigin: true,
    })
      .then(data => {
        const { news } = data;
        news.forEach(item => {
          if (item.area !== 'GEOMETRYCOLLECTION EMPTY' && item.area !== 'POINT EMPTY') {
            currentState.orte.forEach(ort => {
              if ((ort.active || item.isCatastrophy) && ort.area) {
                const ortArea = new google.maps.Polygon({
                  paths: parsePolyStrings(ort.area),
                });
                const newsArea = new google.maps.Polygon({
                  paths: parsePolyStrings(item.area),
                });
                const intersects = checkIntersection(ortArea, newsArea);
                const hasCategorySelected = ort.categories.some(
                  category => category.id === item.category && category.active,
                );

                const reportIDs = reportsToAdd.map(report => report.id);
                if ((intersects && hasCategorySelected) || (intersects && item.isCatastrophy)) {
                  if (!reportIDs.includes(item.id)) {
                    reportsToAdd.push(item);
                  }
                }
              }
            });
          }
        });

        const reportsInStore = getState().reports;
        reportsInStore.forEach(item => {
          currentState.orte.forEach(ort => {
            if ((ort.active || item.isCatastrophy) && ort.area) {
              const ortArea = new google.maps.Polygon({
                paths: parsePolyStrings(ort.area),
              });
              const newsArea = new google.maps.Polygon({
                paths: parsePolyStrings(item.area),
              });
              const intersects = checkIntersection(ortArea, newsArea);
              const hasCategorySelected = ort.categories.some(
                category => category.id === item.category && category.active,
              );

              const reportIDs = reportsNotToRemove.map(report => report.id);
              if ((intersects && hasCategorySelected) || (intersects && item.isCatastrophy)) {
                if (!reportIDs.includes(item.id)) {
                  reportsNotToRemove.push(item);
                }
              }
            }
          });
        });
        const reportIDsInStore = getState().reports.map(report => report.id);
        const reportIDsNotToRemove = reportsNotToRemove.map(report => report.id);
        const reportIDsToAdd = reportsToAdd.map(report => report.id);
        const reportsToRemove = getState().reports.filter(
          report =>
            !reportIDsNotToRemove.includes(report.id) && !reportIDsToAdd.includes(report.id),
        );
        const finalReportsToAdd = reportsToAdd.filter(
          report => !reportIDsInStore.includes(report.id),
        );

        finalReportsToAdd.forEach(report => dispatch(addReport(report)));
        reportsToRemove.forEach(report => dispatch(removeReport(report)));

        dispatch(setLoading(false));
      })
      .fail(() => {
        dispatch(setLoading(false));
      });
  };
}

export function setOrtActive(name, state) {
  return (dispatch, getState) => {
    const userId = localStorage.getItem('userid');
    const currentState = getState();
    currentState.orte.forEach(ort => {
      if (ort.name === name) {
        createOrUpdateSubscription(
          ort.coordinates.lat,
          ort.coordinates.lng,
          ort.radius,
          state,
          ort.subscriptionId || -1,
          userId,
          name,
        ).then(data => {
          dispatch(setOrtSubscriptionId(ort.name, data.id));
          dispatch(setOrtArea(ort.name, data.result));
        });
      }
    });
    dispatch({
      type: actionTypes.SET_ORT_ACTIVE,
      name,
      state,
    });
  };
}

export function setOrtRadius(name, radius) {
  return (dispatch, getState) => {
    const userId = localStorage.getItem('userid');
    const currentState = getState();
    currentState.orte.forEach(ort => {
      if (ort.name === name && ort.coordinates) {
        createOrUpdateSubscription(
          ort.coordinates.lat,
          ort.coordinates.lng,
          radius,
          ort.active,
          ort.subscriptionId || -1,
          userId,
          name,
        ).then(data => {
          dispatch(setOrtSubscriptionId(ort.name, data.id));
          dispatch(setOrtArea(ort.name, data.result));
        });
      }
    });
    dispatch({
      type: actionTypes.SET_ORT_RADIUS,
      name,
      radius,
    });
  };
}

export function setOrtCategories(name, categories) {
  return {
    type: actionTypes.SET_ORT_CATEGORIES,
    name,
    categories,
  };
}

export function setOrtCoordinates(name, lat, lng) {
  return (dispatch, getState) => {
    const userId = localStorage.getItem('userid');
    const currentState = getState();
    currentState.orte.forEach(ort => {
      if (ort.name === name) {
        createOrUpdateSubscription(
          lat,
          lng,
          ort.radius,
          ort.active,
          ort.subscriptionId || -1,
          userId,
          name,
        ).then(data => {
          dispatch(setOrtSubscriptionId(ort.name, data.id));
          dispatch(setOrtArea(ort.name, data.result));
        });
      }
    });
    dispatch({
      type: actionTypes.SET_ORT_COORDINATES,
      name,
      lat,
      lng,
    });
  };
}



// WEBPACK FOOTER //
// ./src/js/actions/actions.js